export const mobile_number = "mobile_number";
export const store_location = "store_location";
export const store_details = "store_details";
export const store_filter = "store_filter";
export const category_products = "category_products";
export const cart_order_details = "cart_order_details";
export const cart_quantity = "cart_quantity";
export const login_prescribe_data = "login_prescribe_data";
export const clear_login_prescribe_data = "clear_login_prescribe_data";
